// Sidebars
import defaultSidebarList from '@/components/Sidebars/SidebarExtraLista'
import defaultSidebarItem from '@/components/Sidebars/SidebarExtraItem'

// Funciones
// const functions = {
// 	sensitive: (e) => {
// 		return e.charAt(0).toUpperCase() + e.slice(1)
// 	}
// }

// Routes
const typeRoutes = {
	newRoute: {name: 'codigo', params: {id: 'new'}},
	editRoute: {name: 'codigo'}
}

// Conexiones
const connections = {
	typeUrl: 'codigos',
	constType: 'codigos'
}

// Listas
const paginationList = {
	results: 9999,
	limit: 9999
}

const sidebarExtra = {
	list: defaultSidebarList,
	item: defaultSidebarItem
}

// Datos a mostrar en el listado
const dataShow = [
	{
		id: 'id',
		name: 'ID',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md6 lg6 xl6',
			card: 'xs12 sm12 md12 lg12 xl6 d-none'
		},
		selected: true
	},
	{
		id: 'tipo_suscripcion',
		name: 'Tipo',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md6 lg6 xl6',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	},
	{
		id: 'porcentaje',
		name: 'Porcentaje',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md6 lg6 xl6',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	},
	{
		id: 'usos',
		name: 'Usos',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md6 lg6 xl6',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	}
]

// Datos formulario Item
const formData = {
	data: {
		tipo_suscripcion: '',
		porcentaje: '',
		usos: ''
	},
	clean() {
		this.data = {
			tipo_suscripcion: '',
			porcentaje: '',
			usos: ''
		}
	}
}

// Tabs para el Item
const tabsItem = [
	{
		id: 'general',
		name: 'General', 
		active: true
	}
]

// Campos en el Item
const fields = [
	{
		name: 'id',
		tabID: 'general',
		titled: true, // Si sale en la cabecera de la CARD
		type: 'id',
		classes: 'xs12 sm12 md12 lg12 xl6 pb-3',
		label: 'ID',
		placeholder: 'ID',
		required: true,
		box: false,
		outline: false,
		persistentHint: false,
		disabled: true
	},
	{
		name: 'tipo_suscripcion',
		tabID: 'general',
		type: 'text',
		classes: 'xs12 sm12 md12 lg12 xl12 pb-3',
		label: 'Tipo',
		placeholder: 'Tipo',
		disabled: false,
	},
	{
		name: 'porcentaje',
		tabID: 'general',
		type: 'text',
		classes: 'xs12 sm12 md12 lg12 xl12 pb-3',
		label: 'Porcentaje',
		placeholder: 'Porcentaje',
		disabled: false,
	},
	{
		name: 'usos',
		tabID: 'general',
		type: 'text',
		classes: 'xs12 sm12 md12 lg12 xl12 pb-3',
		label: 'Usos',
		placeholder: 'Usos',
		disabled: false,
	}
]


export { typeRoutes, connections, formData, tabsItem, dataShow, paginationList, fields, sidebarExtra }
